const routes = [
  {
    path: '/activity/web',
    name: 'activity/web',
    meta: {
      hiddenHead: true, // 隐藏头部
    },
    component: () => import('@/views/activity/web.vue')
  },
  {
    path: '/activity/mobile',
    name: 'activity/mobile',
    meta: {
      hiddenHead: true, // 隐藏头部
    },
    component: () => import('@/views/activity/mobile.vue')
  },
]

export default routes;
